import { Expose, Type, Transform } from 'class-transformer';
import { IsEnum, IsDefined, IsOptional, IsString, IsBoolean, Length } from 'class-validator';
import { Country } from '../common/enums';
import { ParserError } from '../common/errors';

export class AddressCreate {
  constructor(props: Partial<AddressCreate>) {
    Object.assign(this, props);
  }

  @Expose()
  @IsString()
  @Length(1, 35)
  @IsOptional()
  name?: string;

  @Expose({ name: 'companyName' })
  @IsString()
  @IsOptional()
  company?: string;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.replace(/-/g, ''), { toClassOnly: true })
  @Type(() => String)
  phone?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Type(() => String)
  phoneCountryCode?: string;

  @Expose()
  @IsOptional()
  @IsString()
  email?: string;

  @Expose()
  @IsDefined()
  @IsString()
  street1?: string;

  @Expose()
  @IsOptional()
  @IsString()
  street2?: string;

  @Expose()
  @IsOptional()
  @IsString()
  street3?: string;

  @Expose()
  @IsString()
  @IsOptional()
  city?: string;

  @Expose()
  @IsOptional()
  @IsString()
  state?: string;

  @Expose()
  @IsEnum(Country)
  @IsOptional()
  country?: Country;

  @Expose()
  @IsBoolean()
  @IsOptional()
  @Type(() => Boolean)
  @Transform(({ value }) => typeof (value) === 'string' ? value === 'Y' : value)
  isResidential?: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  @Type(() => String)
  postalCode?: string;

  errors?: ParserError[] = [];
}
